













// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultAloPartenaire, AloPartenaire } from '@/models/alo/AloPartenaire';
import * as rules from '@/utils/validationRules'
import EditBasePartenaire from '@/components/partenaire/edit/EditBasePartenaire.vue';

@Component({
  name: 'EditConfig',    
  components:{EditBasePartenaire},  
  props: {   
    priorityEditable:{
      type:Boolean,
      default:true      
    },
    enableEditable:{
      type:Boolean,
      default:true      
    },  
  }
})
export default class EditConfig extends Vue {
  
  private partenaire = getDefaultAloPartenaire()
  private priorityEditable!:boolean
  private enableEditable!:boolean
  
  
 
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloPartenaire) {    
    this.partenaire = (this.$refs.baseEdit as EditBasePartenaire).edit(item)
  }   
}
